import React from 'react';

export const path =
  'M8,4.95854812 L10.9592921,3.25 C11.1984385,3.11192881 11.5042337,3.19386639 11.6423048,3.4330127 L12.1423048,4.29903811 C12.280376,4.53818442 12.1984385,4.84397962 11.9592921,4.98205081 L8.73205081,6.84529946 L12.2631397,8.8839746 C12.502286,9.02204578 12.5842236,9.32784099 12.4461524,9.5669873 L11.9461524,10.4330127 C11.8080812,10.672159 11.502286,10.7540966 11.2631397,10.6160254 L8,8.73205081 L8,12.5 C8,12.7761424 7.77614237,13 7.5,13 L6.5,13 C6.22385763,13 6,12.7761424 6,12.5 L6,8.42264973 L2.4330127,10.4820508 C2.19386639,10.620122 1.88807119,10.5381844 1.75,10.2990381 L1.25,9.4330127 C1.11192881,9.19386639 1.19386639,8.88807119 1.4330127,8.75 L4.73205081,6.84529946 L1.73686028,5.1160254 C1.49771397,4.97795422 1.41577639,4.67215901 1.55384758,4.4330127 L2.05384758,3.5669873 C2.19191876,3.32784099 2.49771397,3.24590341 2.73686028,3.3839746 L6,5.26794919 L6,1.5 C6,1.22385763 6.22385763,1 6.5,1 L7.5,1 C7.77614237,1 8,1.22385763 8,1.5 L8,4.95854812 Z';

export default class Asterisk extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <path d={path} className="fill-current" />
      </g>
    );
  }
}
